var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.tokenAuth)?_c('Nav'):_vm._e(),_c('div',{class:_vm.tokenAuth?'makeStyles-content-10':'height-100'},[_c('router-view'),_c('loader'),_c('alert-message')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }